









































































import {Component, Watch, Prop, Vue} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import Motorista from '@/model/resource/Motorista'
import Responsavel from '@/model/resource/Responsavel'
import DriverPerformanceBar from '@/components/itrack/DriverPerformanceBar.vue'

@Component({components: { DriverPerformanceBar }})
export default class ItDriverPerformance extends Vue {
  @Prop({type: Object, required: true}) motorista!: Motorista
  @Prop({type: Boolean, default: false}) isBaixasPortal!: boolean
  @Getter('auth/responsavel') user!: Responsavel
}
